import { getToken } from "@/services/api/auth.js";
import { sessionWasRevoked, backToAdmin } from "@/services/sso.js";
import { isCorporationNotReady } from "@/services/corporationNotReady.js";
import { flagNotReady } from "@/services/notReady.js";

export async function apiRequest({ client = {}, orderBy= [], method = "", url, params = {}, body = {}, sendToken = true, headers = {}, responseType, onUploadProgress }){
    try {
        let orderByStr = '';
        if (orderBy.length) {
            orderByStr = 'orderBy=' + orderBy
                .map(s => `${s.key} ${s.desc ? 'desc' : 'asc'}`)
                .join('|')
        }
        if (sendToken) {
            const token = getToken();
            headers.Authorization = `Bearer ${token}`;
        }

        let finalUrl = url;
        if (orderByStr) {
            finalUrl += (url.includes('?') ? '&' : '?') + orderByStr;
        }

        const response = await client.request({
            method,
            url: finalUrl,
            params,
            data: body,
            headers,
            // So passado quando pedido (ex: 'blob', para baixar um arquivo
            // exportado) -- o default do axios ('json') continua valendo
            // para toda chamada que nao precisa disto.
            ...(responseType ? { responseType } : {}),
            // So no envio de arquivo grande (audio de reuniao): a tela mostra o andamento.
            ...(onUploadProgress ? { onUploadProgress } : {}),
        });

        return response.data || response;
    } catch (error) {
        if (sessionWasRevoked(error)) {
            // Saiu da plataforma em outra aplicacao. Aqui nao ha tela de login
            // para onde cair: quem resolve sessao e o admin.
            localStorage.clear();
            backToAdmin({
                reason: 'sessao-encerrada',
                returnTo: window.location.pathname + window.location.search,
            });

            // A pagina esta indo embora: nao resolve nem rejeita, para a tela
            // nao piscar um erro no caminho.
            return new Promise(() => {});
        }

        if (isCorporationNotReady(error)) {
            // As tabelas do ata desta empresa ainda estao sendo criadas (o relogio da API confere de 2 em 2 minutos). Em vez de um erro em
            // cada tela, sobe a pagina de espera (App.vue), que pergunta sozinha ate ficar pronto e entao recarrega.
            flagNotReady(error);

            // A pagina vai ser recarregada: nao resolve nem rejeita, para nenhuma tela mostrar erro por baixo da pagina de espera.
            return new Promise(() => {});
        }

        return Promise.reject(error);
    }
}
